<template>
	<div class="footer">
		<div class="up bg_theme">
			<div class="up_box clear_both">
				<div class="up_l">
					<img src="../../../assets/logo.png" alt="">
					<!-- <p class="phone"><i class="phone_icon"></i>0551-68562028</p> -->
					<p class="phone"><i class="phone_icon"></i>18599158171</p>
					<p class="addr"><i class="addr_icon"></i>安徽省合肥市高新区望江西路4899号欧普康视1-B建筑六楼东南</p>
				</div>
				
				<div class="up_c clear_both">
					<ul class="up_list">
						<li class="head_li">使用指导</li>
						<li><a href="javascript: void(0);" @click="toGuidePro">专业版指导</a></li>
						<li><a href="javascript: void(0);" @click="toGuideFun">趣味版指导</a></li>
						<li><a href="javascript: void(0);" @click="toGuideHelp">帮助中心</a></li>
					</ul>
					<ul class="up_list">
						<li class="head_li">科普园地</li>
						<li><a href="javascript: void(0);" @click="toSciencePark">科普园地</a></li>
					</ul>
					<ul class="up_list">
						<li class="head_li">康复案例</li>
						<li><a href="javascript: void(0);" @click="toCase">康复案例</a></li>
						<li><a href="javascript: void(0);" @click="toProcess">治疗流程</a></li>
						<li><a href="javascript: void(0);" @click="toDigital">康复数据</a></li>
					</ul>
					<ul class="up_list">
						<li class="head_li">产品下载</li>
						<li><a href="javascript: void(0);" @click="toDownload">产品下载</a></li>
						<li><a href="http://cloud.uflycloud.com/" target="_blank">科飞云</a></li>
					</ul>
				</div>
				
				<ul class="up_r clear_both">
					<li class="up_r_item" style="margin-right: 18px;">
						<div class="up_code">
							<img src="../../../assets/publick_code.jpg" alt="">
						</div>
						<p class="up_code_desc">微信公众号</p>
					</li>
					<li class="up_r_item">
						<div class="up_code">
							<img src="../../../assets/wechat_code.jpg" alt="">
						</div>
						<p class="up_code_desc">微信小程序</p>
					</li>
				</ul>
			</div>
		</div>
		<div class="down">COPYRIGHT © 2016 合肥科飞视觉科技有限公司 科飞视觉版权所有&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;皖ICP备13017400号-1</div>
	</div>
</template>

<script>
	export default {
		methods: {
			/******************** @Events ************************/
			// 专业版指导
			toGuidePro() {
				let path = this.$route.path;
				path != '/index/guide' && this.$router.push({path: '/index/guide?type=pro'});
			},
			// 趣味版指导
			toGuideFun() {
				let path = this.$route.path;
				path != '/index/guide' && this.$router.push({path: '/index/guide?type=fun'});
			},
			// 帮助中心
			toGuideHelp() {
				let path = this.$route.path;
				path != '/index/guide' && this.$router.push({path: '/index/guide?type=help'});
			},
			// 科普园地
			toSciencePark() {
				let path = this.$route.path;
				path != '/index/science_park' && this.$router.push({path: '/index/science_park'});
			},
			// 康复案例
			toCase() {
				let path = this.$route.path;
				path != '/index/recovery_case' && this.$router.push({path: '/index/recovery_case?type=case'});
			},
			// 治疗流程
			toProcess() {
				let path = this.$route.path;
				path != '/index/recovery_case' && this.$router.push({path: '/index/recovery_case?type=process'});
			},
			// 康复数据
			toDigital() {
				let path = this.$route.path;
				path != '/index/recovery_case' && this.$router.push({path: '/index/recovery_case?type=digital'});
			},
			// 产品下载
			toDownload() {
				let path = this.$route.path;
				path != '/index/download' && this.$router.push({path: '/index/download'});
			}
		}
	}
</script>

<style scoped>
	.footer .up{ height: 374px; }
	.footer .up_box{ width: 1200px;margin: 0 auto;padding: 65px 0 0 0; }
	.footer .up_l{ float: left;width: 295px; }
	.footer .phone{ position: relative;margin-top: 90px;padding: 0 0 0 36px;font-size: 16px;color: #f5f5f5;line-height: 20px; }
	.footer .addr{ position: relative;margin-top: 18px;padding: 0 0 0 36px;font-size: 16px;color: #f5f5f5;line-height: 20px; }
	.footer .phone_icon{ display: block;position: absolute;width: 24px;height: 24px;top: -2px;left: 0;background-image: url(../../../assets/phone.png);background-size: cover; }
	.footer .addr_icon{ display: block;position: absolute;width: 24px;height: 24px;top: -2px;left: 0;background-image: url(../../../assets/addr.png);background-size: cover; }
	.footer .up_c{ float: left;margin-left: 90px; }
	.footer .up_list{ float: left;width: 90px;margin-right: 20px; }
	.footer .up_list li{ margin-bottom: 4px; }
	.footer .up_list li a{ color: #f5f5f5;line-height: 30px; }
	.footer .up_list li a:hover{ text-decoration: underline; }
	.footer .up_list .head_li{ margin-bottom: 10px;font-size: 16px;color: #f5f5f5;font-weight: bold;line-height: 30px; }
	.footer .up_r{ float: right; }
	.footer .up_r_item{ float: left;width: 120px; }
	.footer .up_code{ height: 120px;background: #fff; }
	.footer .up_code img{ display: block;width: 100%;height: 100%; }
	.footer .up_code_desc{ margin-top: 8px;color: #f5f5f5;text-align: center;line-height: 22px; }
	
	.footer .down{ background: #041546;font-size: 12px;color: #f5f5f5;text-align: center;line-height: 26px; }
</style>
